import { Button as BaseButton, ButtonProps } from "../../../ui/button";

export const Button = ({
  type = "button",
  variant = "outline",
  ...rest
}: ButtonProps) => {
  const getVariant = () => {
    if (type === "submit" || type === "reset") {
      return "primary";
    }

    return variant;
  };

  return <BaseButton type={type} variant={getVariant()} {...rest} />;
};
